import { apiConstants } from "../_constants";
import { authHeader, handleResponse } from "../_helpers";
export const subscriptionsService = {
    subscriptionsAdd,
    subscriptionsList,
    subscriptionsDelete,
    getPaymentDetails,
    getRazorPaySubscriptionIDMobile
};

// create subscriptions
function subscriptionsAdd(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/addsubscriptions", requestOptions).then(
        handleResponse
    );
}
//get subscription list
function subscriptionsList(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(
        apiConstants.apiUrl + "/getsubscriptionsList",
        requestOptions
    ).then(handleResponse);
}
//delete subscriptions
function subscriptionsDelete(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(
        apiConstants.apiUrl + "/deletesubscriptions",
        requestOptions
    ).then(handleResponse);
}
function getPaymentDetails(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(
        apiConstants.apiUrl + "/getpaymentdetetails",
        requestOptions
    ).then(handleResponse);
}

function getRazorPaySubscriptionIDMobile(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + '/getrazorpaysubscriptionidmobile', requestOptions).then(
        handleResponse,
    );
}
